import React, { useEffect, useState } from "react";

export const Header = ({ headdata }) => {
  const fullText = headdata ? headdata.title : "Loading";
  const [displayedText, setDisplayedText] = useState("");
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (index < fullText.length) {
      const timeout = setTimeout(() => {
        setDisplayedText((prev) => prev + fullText.charAt(index));
        setIndex(index + 1);
      }, 120); // speed of typing
      return () => clearTimeout(timeout);
    }
  }, [index, fullText]);

  return (
    <header id="header">
      <div className="intro">
        <video
          className="heroimage"
          src="../img/3141210-uhd_3840_2160_25fps.mp4"
          autoPlay
          loop
          muted
          style={{ width: "100%" }}
        />
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div
                className="col-md-8 col-md-offset-2 intro-text"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100vh",
                  textAlign: "center",
                  color: "#fff",
                }}
              >
                {/* Show title directly */}
                <h1>{headdata ? headdata.title : "Loading..."}</h1>

                <p>{headdata ? headdata.paragraph : "Loading..."}</p>

                <a
                  href="/about"
                  className="btn btn-custom btn-lg page-scroll"
                >
                  Explore More
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
